import { createContext, useContext, useEffect, useState } from 'react';

const CartCtx = createContext(null);
const KEY = 'cart_v1';

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const i = prev.findIndex((x) => x.product_id === product.product_id);
      if (i >= 0) {
        const next = [...prev];
        next[i] = { ...next[i], qty: next[i].qty + qty };
        return next;
      }
      return [...prev, {
        product_id: product.product_id,
        name: product.name,
        // Guardamos el precio efectivo (con promoción vigente si aplica) —
        // es lo que se cobra. `list_price` queda para mostrar tachado.
        price: product.has_promotion ? Number(product.effective_price) : Number(product.price),
        list_price: Number(product.original_price ?? product.price),
        has_promotion: !!product.has_promotion,
        discount_pct: Number(product.discount_pct) || 0,
        image: (product.images || [])[0] || '',
        stock: product.stock,
        qty,
      }];
    });
  };

  const remove = (product_id) =>
    setItems((prev) => prev.filter((x) => x.product_id !== product_id));

  const updateQty = (product_id, qty) =>
    setItems((prev) => prev.map((x) =>
      x.product_id === product_id ? { ...x, qty: Math.max(1, qty) } : x,
    ));

  const clear = () => setItems([]);

  const subtotal = items.reduce((s, x) => s + x.price * x.qty, 0);
  const count = items.reduce((s, x) => s + x.qty, 0);

  return (
    <CartCtx.Provider value={{ items, add, remove, updateQty, clear, subtotal, count }}>
      {children}
    </CartCtx.Provider>
  );
};

export const useCart = () => useContext(CartCtx);
